import { Menu, Avatar, ActionIcon } from '@mantine/core'
import { IconBrandTelegram, IconLogout, IconUser } from '@tabler/icons-react'
import { useAuth } from '../auth/AuthContext'
import { useNavigate } from 'react-router-dom'

export default function AccountChip() {
  const { user, profile, signOut } = useAuth()
  const nav = useNavigate()

  const displayName = (profile as any)?.name || user?.name || (profile?.email ? profile.email.split('@')[0] : user?.email) || 'User'
  const displayEmail = profile?.email || user?.email || ''
  const avatarUrl = (profile as any)?.avatarUrl || (user as any)?.picture
  const initial = (displayName || displayEmail || 'U').substring(0, 1).toUpperCase()
  const supportTelegramUrl = (import.meta as any).env?.VITE_SUPPORT_TG_URL || 'https://t.me/fravai_support_bot'

  return (
    <Menu shadow="md" width={260} withArrow>
      <Menu.Target>
        <ActionIcon
          variant="subtle"
          size={42}
          radius="xl"
          className="header-avatar-button"
          aria-label="Профиль"
        >
          <Avatar src={avatarUrl} alt={displayName} radius="xl" size={32}>{initial}</Avatar>
        </ActionIcon>
      </Menu.Target>
      <Menu.Dropdown>
        <Menu.Item leftSection={<IconUser size={16} />} onClick={() => nav('/profile')}>Профиль</Menu.Item>
        <Menu.Item
          component="a"
          href={supportTelegramUrl}
          target="_blank"
          rel="noopener noreferrer"
          leftSection={<IconBrandTelegram size={16} />}
        >
          Поддержка
        </Menu.Item>
        <Menu.Item color="red" leftSection={<IconLogout size={16} />} onClick={() => { signOut(); nav('/auth?returnTo=/dashboard', { replace: true }) }}>Выйти</Menu.Item>
      </Menu.Dropdown>
    </Menu>
  )
}

